import { QIcon_outlink } from '@repo/icons/index'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import Cookies from 'universal-cookie'
import { useLessonInfo } from '../../../modules/apis/student/lesson/review/queries'
import { COOKIE_DOMAIN } from '../../../modules/envVars'
import useIsMobile from '../../../modules/hooks/common/useIsMobile'
import { s_preparation } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { STUDENT_DATA_REF_LIST } from '../../../modules/ids/e2e/tutor'

interface DocNoteTabPanel {
  documentUrl: string
  ringledocUrl: string
  iframeRef: any
  ringleDocToken?: any
  currentUser?: any
  specialLesson?: boolean
  height?: any
  style?: any
}

//유저 정보 로딩용
export const getUserSetting = (currentUser) => {
  const cookies = new Cookies()
  let session_role = 'admin'
  let username = 'none'
  const email = currentUser?.profile?.email
  const is_ringle = email?.includes('@') ? email.split('@')[1] === 'ringleplus.com' : false

  if (currentUser?.is_ringle_member) {
    session_role = 'admin'
  } else if (is_ringle) {
    session_role = 'admin'
  } else {
    session_role = cookies.get('session_role')
  }

  //tutor
  if (currentUser?.role == 1) {
    username = currentUser?.profile?.first_name
  }
  //student
  else if (currentUser?.role == 0) {
    username = currentUser?.profile?.name
  } else {
    username = currentUser?.profile?.name
  }

  const middle = COOKIE_DOMAIN.split('.')[1]
  const domain = '.' + middle + '.com'

  return {
    session_role: session_role,
    username: username,
    domain: domain,
  }
}

export const DocNoteTabPanel = ({
  documentUrl,
  ringledocUrl,
  iframeRef,
  ringleDocToken,
  currentUser,
  specialLesson,
  height,
  style,
}: DocNoteTabPanel) => {
  const { t } = useTranslation()
  const [windowLoaded, setWindowLoaded] = useState(false)
  const [tokenLoaded, setTokenLoaded] = useState(false)
  const [someInterval, setSomeInterval] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const cookies = new Cookies()
  //유저 정보 로딩
  const { session_role, username, domain } = getUserSetting(currentUser)

  //쿠키에 정보 넣는 세팅
  const settingCookie = async (ringleDocToken, session_role, username) => {
    cookies.set('temp_ringleDocToken', ringleDocToken, { domain: domain, path: '/' })
    cookies.set('temp_role', session_role, { domain: domain, path: '/' })
    cookies.set('temp_username', username, { domain: domain, path: '/' })
  }

  //Iframe으로 토큰 쏴주기
  const dispatchToken = () => {
    try {
      iframeRef.current.contentWindow.postMessage(
        { ringleDocToken: ringleDocToken, username: username, session_role: session_role },
        '*'
      )
    } catch (err) {
      console.log(err)
    }
  }

  //props로 받아오므로 바로 쿠키에 넣어주기
  useEffect(() => {
    settingCookie(ringleDocToken, session_role, username).then(() => {
      setLoaded(true)
    })
  }, [])

  //토큰 로딩 되면 Iframe으로 2차로 쏴주기
  useEffect(() => {
    if (!loaded) return
    if (!windowLoaded) return
    if (someInterval) return
    dispatchToken()
    const _interval = setInterval(function () {
      dispatchToken()
    }, 1000)
    setSomeInterval(_interval)
  }, [windowLoaded, someInterval, loaded])

  //링글닥에서 토큰 받았는지 체크
  useEffect(() => {
    if (!loaded) return
    window.addEventListener('message', (e) => {
      if (e.data) {
        if (e.data.loaded) {
          setTokenLoaded(true)
        }
      }
    })
  }, [loaded])

  //링글닥에서 토큰 받았으면 이제 Iframe Postmessage 그만
  useEffect(() => {
    if (!loaded) return
    if (!tokenLoaded) return
    if (!someInterval) return
    clearInterval(someInterval)
  }, [tokenLoaded, someInterval, loaded])

  return (
    <div style={{ height: height }}>
      {!specialLesson ? (
        <div className="h-full">
          {documentUrl ? (
            <iframe
              data-ref={STUDENT_DATA_REF_LIST.iframe_ringle_doc}
              ref={iframeRef}
              src={`${documentUrl}?rm=embedded`}
              className={style}
            />
          ) : (
            <div className="mt-[100px] text-center">{t(s_preparation.google_docs_is_being_generated)}</div>
          )}
        </div>
      ) : (
        <div className="h-full">
          {ringledocUrl && loaded ? (
            <iframe
              data-ref={STUDENT_DATA_REF_LIST.iframe_ringle_doc}
              ref={iframeRef}
              src={`${ringledocUrl}`}
              onLoad={(e) => setWindowLoaded(true)}
              className={style}
              allow="geolocation; https://docs.ringleplus.com; https://docs.ringlefront.com; http://localhost:3000; clipboard-read; clipboard-write;"
            />
          ) : (
            <div className="mt-[100px] text-center">{'Ringle Docs is generating...'}</div>
          )}
        </div>
      )}
    </div>
  )
}

type DocNoteSnapshotPanelPropsType = {
  documentUrl: string
  ringledocUrl: string
  iframeRef: any
  height: any
  style?: any
}

export const DocNoteSnapshotPanel = ({
  documentUrl,
  ringledocUrl,
  iframeRef,
  height,
  style,
}: DocNoteSnapshotPanelPropsType) => {
  const { t } = useTranslation()
  const [uuid, setUuid] = useState('')

  useEffect(() => {
    if (ringledocUrl) {
      setUuid(ringledocUrl.split('/').pop())
    }
  }, [])

  return (
    <div style={{ height: height }}>
      {
        <div className="h-full">
          {uuid ? (
            <iframe
              ref={iframeRef}
              src={`https://docs.ringleplus.com/snapshot/${uuid}`}
              className={style}
              allow="geolocation;"
            />
          ) : (
            <div className="mt-[100px] text-center">{'Ringle Docs has not been generated...'}</div>
          )}
        </div>
      }
    </div>
  )
}

interface DocNoteSnapshotReviewTabPanel {
  documentUrl: any
  ringledocUrl: any
  iframeRef: any
  ringleDocToken?: any
  currentUser?: any
  height?: any
  style?: any
}
//학생 복습페이지용
export const DocNoteSnapshotReviewTabPanel = ({
  documentUrl,
  ringledocUrl,
  iframeRef,
  ringleDocToken,
  currentUser,
  specialLesson,
  height,
  style,
}: DocNoteTabPanel) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const [windowLoaded, setWindowLoaded] = useState(false)
  const [tokenLoaded, setTokenLoaded] = useState(false)
  const [someInterval, setSomeInterval] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const cookies = new Cookies()
  const { session_role, username, domain } = getUserSetting(currentUser)

  const router = useRouter()
  const { lessonId } = router.query
  const { data: lessonInfo } = useLessonInfo(Number(lessonId))

  //쿠키 세팅하기
  const settingCookie = async (ringleDocToken, session_role, username) => {
    cookies.set('temp_ringleDocToken', ringleDocToken, { domain: domain, path: '/' })
    cookies.set('temp_role', session_role, { domain: domain, path: '/' })
    cookies.set('temp_username', username, { domain: domain, path: '/' })
  }

  //Iframe으로 토큰 쏴주기
  const dispatchToken = () => {
    try {
      const token = ringleDocToken == 'undefined' ? lessonInfo.ringledoc : ringleDocToken
      iframeRef.current.contentWindow.postMessage(
        { ringleDocToken: token, username: username, session_role: session_role },
        '*'
      )
    } catch (err) {
      console.log(err)
    }
  }

  //레슨인포 받아왔는지 체크 (CSR이지만 데이터 받아올때까지 렌더링)
  useEffect(() => {
    if (!lessonInfo) return
    setLoading(true)
  }, [loading, lessonInfo])

  //레슨 인포 받아오고, 토큰 쿠키 설정
  useEffect(() => {
    if (!loading) return
    const token = ringleDocToken == 'undefined' ? lessonInfo.ringledoc : ringleDocToken
    settingCookie(token, session_role, username).then(() => {
      setLoaded(true)
    })
  }, [loading])

  //토큰 쿠키가 안되는 경우를 위해 Iframe postmessage도 활용
  useEffect(() => {
    if (!loaded) return
    if (!windowLoaded) return
    if (someInterval) return
    dispatchToken()
    const _interval = setInterval(function () {
      dispatchToken()
    }, 1000)
    setSomeInterval(_interval)
  }, [windowLoaded, someInterval, loaded])

  //링글닥에서 토큰 로딩 됬는지 인식하는 곳.
  useEffect(() => {
    if (!loaded) return
    window.addEventListener('message', (e) => {
      if (e.data) {
        if (e.data.loaded) {
          setTokenLoaded(true)
        }
      }
    })
  }, [loaded])

  //링글닥에서 토큰 로딩이 되면 이제 그만 쏴주기
  useEffect(() => {
    if (!loaded) return
    if (!tokenLoaded) return
    if (!someInterval) return
    clearInterval(someInterval)
  }, [tokenLoaded, someInterval, loaded])

  // 모바일에서 snapshot url로 사용
  const iframeUrl = isMobile ? ringledocUrl?.replace('/docs/', '/snapshot/') || ringledocUrl : ringledocUrl

  if (!lessonInfo) return null
  return (
    <div style={{ height: height }} className="w-full">
      {!specialLesson ? (
        <div className="h-full pl-[120px]">
          {documentUrl ? (
            <iframe ref={iframeRef} src={`${documentUrl}?rm=embedded`} className={style} />
          ) : (
            <div className="mt-[100px] text-center">{t(s_preparation.google_docs_is_being_generated)}</div>
          )}
        </div>
      ) : (
        <div className="h-full">
          {iframeUrl && loaded ? (
            <iframe
              ref={iframeRef}
              src={`${iframeUrl}`}
              onLoad={(e) => setWindowLoaded(true)}
              className={style}
              allow="geolocation; https://docs.ringleplus.com; https://docs.ringlefront.com; http://localhost:3000; clipboard-read; clipboard-write"
            />
          ) : (
            <div className="mt-[100px] text-center">{'Ringle Docs is generating...'}</div>
          )}
        </div>
      )}
    </div>
  )
}

type IconOpenNewTabPropsType = {
  ringleDocUrl: string
  token: string
  currentUser: any
}

export const IconOpenNewTab = ({ ringleDocUrl, token, currentUser }: IconOpenNewTabPropsType) => {
  const [seesionRole, setSessionRole] = useState('tutor')
  const [username, setUsername] = useState('Anonymous')

  useEffect(() => {
    const { session_role, username, domain } = getUserSetting(currentUser)
    setUsername(username)
    setSessionRole(session_role)
  }, [])

  return (
    <div>
      {
        <div className="h-full">
          {ringleDocUrl && token && (
            <a
              href={`${ringleDocUrl}?token=${token}&role=${seesionRole}&username=${username}`}
              target="_blank"
              className=""
              rel="noreferrer"
            >
              <QIcon_outlink className="h-20 w-20" />
            </a>
          )}
        </div>
      }
    </div>
  )
}
